<template>
  <div id="settings">
    <DashboardHeader />
    <div class="panels">
      <div class="panel-left-12-rem">
        <DashboardSideMenu :organizations="organizations" :custom-feats="props.customFeats" />
      </div>
      <div class="panel-right-flex">
        <router-view v-if="!isLoading" v-model:organization-id="organizationId" :organizations="organizations" @error="$emit('error', $event)" @scroll="$emit('scroll', $event)" @refresh-organizations="refreshOrganizations()" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from "vue";
import useApi from "../utils/apiCalls.js";

import DashboardHeader from "../components/DashboardHeader.vue";
import DashboardSideMenu from "../components/DashboardSideMenu.vue";

const isLoading = ref(true);
const organizations = ref([]);
const organizationId = ref(null);

const emit = defineEmits(["error", "info", "scroll"]);
const props = defineProps(["customFeats"]);
const { apiGetRequest } = useApi(emit);

const refreshOrganizations = () => {
  isLoading.value = true;
  apiGetRequest({
    path: `/organizations-admin`,
    onSuccess: data => {
      organizations.value = data;
      if (organizationId.value == null && data.length > 0) {
        organizationId.value = data[0].id;
      } else if (data.length === 0) {
        organizationId.value = null;
      }
      nextTick().then(() => {
        isLoading.value = false;
      });
    },
  });
};

refreshOrganizations();
</script>
